/**
 * React Query hook for the departments catalogue.
 */

import { useQuery } from '@tanstack/react-query';
import { getDepartments } from '@/services/geography.service';
export type { Department } from '@/types/geography.types';

/** Department list for a country (default `FR`). */
export function useDepartments(country: string = 'FR') {
  return useQuery({
    queryKey: ['departments', country],
    queryFn: () => getDepartments(country),
  });
}
